<template>
    <CustomHeader v-if="!isComponentUse" :text="$t('common.deposite')" :is-popup-close-back-icon="true"
        @close-popup="backNavigate" :show-fund="true" @go-to-fund="goToFund" />
    <div class="deposit_container">
        <div class="channel_text">{{ $t('common.paymentChannel') }}：</div>
        <div class="channel_list">
            <div class="channel_card" v-for="item in dataSet.channelList" :key="item.name"
                :class="dataSet.activeChannel.id == item.id ? 'active_channel' : ''" @click="selectChannel(item)">
                {{ item.name }}
            </div>
        </div>
        <div
            v-if="props.dataSet.activeChannel.channelType == '3' || props.dataSet.activeChannel.channelType == '4' || props.dataSet.activeChannel.channelType == '5'">
            <ErcCard :address="props.dataSet.ercCode" :minAmount="props.dataSet.minErcAmount"
                :maxAmount="props.dataSet.maxErcAmount" :typeTitle="props.dataSet.activeChannel.name" />
        </div>
        <div v-else>
            <div class="line"></div>
            <div class="bonus_select">
                <van-checkbox v-model="selecTopup">{{ $t('deposit.promotions') }}</van-checkbox>
            </div>
            <div class="deposit_notice">
                <img src="@/assets/loginRegister/notice.png" alt="">
                {{ $t('deposit.bonuseRedeem') }} {{ dataSet.turnOverValue }}x {{ $t('deposit.invoicing') }}
            </div>
            <div class="sub_container">
                <InputField v-model="selectedAmount"
                    :labelText="$t('deposit.valueLabel') + ' (' + dataSet.min_amount + ' ~ ' + dataSet.max_amount + ')'"
                    :isTopupVisible="selecTopup" :giftAmount="dataSet.giftAmount" />
                <div v-if="dataSet.activeChannel.channelType == '7' || dataSet.activeChannel.channelType == '2'">
                    <div class="input_field">
                        <div class="inputLabel">CPF ID</div>
                        <van-field v-model="cpfID" type="number" :placeholder="$t('withdraw.cpfIdPlaceholder')">
                            <template #right-icon>
                                <div class="right-wrapper">
                                    <van-icon v-if="cpfID" name="clear" class="custom-clear" @click.stop="onClear" />
                                    <van-icon name="credit-pay" />
                                </div>
                            </template>
                        </van-field>
                    </div>
                    <div class="errorText" v-if="dataSet.showCPFIdError">
                        {{ $t('withdraw.cpfErrorText') }}</div>
                </div>

                <van-row class="amount_card_list">
                    <van-col span="8" v-for="item in dataSet.amountList" :key="item.fillValue" style="padding: 5px;">
                        <AmountCard :amount="item.fillValue" :isActiveAmount="dataSet.selectedAmount == item.fillValue"
                            :giftRatio="item.giftRatio" :isTopupVisible="selecTopup"
                            @handleCardClick="selectAmountCard(item)" />
                    </van-col>
                </van-row>

                <van-row class="note_text" v-if="selecTopup">
                    <van-col span="4">
                        <img src="@/assets/deposit/deposit_bonus.png" alt="">
                    </van-col>
                    <van-col span="20"> {{ $t('common.deposite') }} R$ {{ formatCurrency(selectedAmount) }} {{
                        $t('deposit.receive') }}
                        R$
                        {{ formatCurrency(dataSet.giftAmount) }}
                        {{ $t('deposit.asaGift') }}.</van-col>
                </van-row>
            </div>


            <div class="btn_container">
                <MainButton :title="$t('common.deposite')" :activeStatus="dataSet.isFillField"
                    @click="confirmDeposit" />
            </div>


        </div>

        <div v-if="userStore.isEnableRechargeNotice && dataSet.activeChannel.rechargeNotice" class="descriptionContainer">
            <div class="noticeText">{{ $t('common.notice') }}</div>
            <div v-html="dataSet.activeChannel.rechargeNotice"></div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import InputField from './components/inputField.vue';
import AmountCard from './components/amountCard.vue';
import { PayChannel } from '@/types/common';
import { formatCurrency } from '@/utils/commonFunction';
import { useUserStore } from '@/stores/user';
import { DepositData } from '@/view/deposit/supportScript';
import MainButton from '../components/common/mainButton.vue';
import CustomHeader from '../components/common/customHeader.vue';
import { useRouter } from 'vue-router';
import ErcCard from '@/themes/themeOne/deposit/components/ercCard.vue';
const props = defineProps<{
    dataSet: DepositData
    isComponentUse?: boolean
}>()
const selecTopup = ref(props.dataSet.selecTopup)
const selectedAmount = ref(props.dataSet.selectedAmount)
const cpfID = ref(props.dataSet.cpfID)
const userStore = useUserStore()
const router = useRouter()
const emit = defineEmits(['selectChannel', 'updateSelecTopup', 'updateSelectedAmount', 'updateCpfID', 'selectAmountCard', 'confirmDeposit'])
const selectChannel = (item: PayChannel) => {
    emit('selectChannel', item)
}
watch(selecTopup, (val) => {
    emit('updateSelecTopup', val)
})
watch(selectedAmount, (val) => {
    emit('updateSelectedAmount', val)
})
watch(cpfID, (val) => {
    emit('updateCpfID', val)
})
watch(() => props.dataSet, (newVal) => {
    selectedAmount.value = newVal.selectedAmount
}, { deep: true, immediate: true })

const selectAmountCard = (select: any) => {
    selectedAmount.value = select.fillValue
    emit('selectAmountCard', select)
}
const confirmDeposit = () => {
    emit('confirmDeposit')
}
const onClear = () => {
    cpfID.value = ''
}
const backNavigate = () => {
    userStore.setRechargeBonusType(0)
    userStore.setTakeFirstDeposit(false)
    router.go(-1)
}
const goToFund = () => {
    router.replace({ path: '/fundsHistory', query: { tabIndex: 0 } })
}
</script>
<style scoped>
.deposit_container {
    display: flex;
    justify-content: center;
    padding: 50px 0;
    flex-direction: column;
    font-size: 20px;
}

.channel_text {
    color: #ffffffd9;
    font-size: 14px;
    padding-top: 15px;
    padding-left: 25px;
}

.channel_list {
    display: flex;
    flex-direction: row;
    overflow-x: auto;
    white-space: nowrap;
    padding: 10px 25px;
}

.channel_list::-webkit-scrollbar {
    display: none;
}

.channel_card {
    border-radius: 5px;
    width: 70px;
    color: #ffffff;
    background-color: #ffffff26;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding: 10px 30px;
    margin-right: 10px;
    font-size: 14px;
    height: 30px;
}

.active_channel {
    background-image: linear-gradient(180deg, #F8D8A7 0%, #F0A853 100%);
    color: #12151A;
    border-radius: 5px;
}

.deposit_notice {
    display: flex;
    align-items: center;
    border-radius: 10px;
    color: #ffffffa6;
    font-size: 14px;
    margin: 15px 25px 0;
    background-color: #ffffff26;
    padding: 10px;
}

.deposit_notice img {
    width: 20px;
    opacity: 0.5;
    height: 18px;
    padding-right: 10px;
}

.amount_card_list {
    padding: 15px 0;
}

.btn_container {
    padding: 30px 60px;
}

.bonus_select {
    padding: 10px 25px 15px;
}

.bonus_select>>>.van-checkbox__label {
    color: #ffffff73;
    font-size: 14px;
}

.bonus_select>>>.van-checkbox__icon--round {
    font-size: 15px;
    background: #fff;
    border-radius: 30px;
}

.bonus_select>>>.van-checkbox__icon--checked .van-icon {
    background-color: #39bb00 !important;
    border-color: #39bb00 !important;
}

.note_text {
    padding: 10px;
    border-radius: 10px;
    background-color: #ffffff14;
    font-size: 12px;
    color: #ffffffa6;
}

.note_text .van-col {
    display: flex;
    align-items: center;
}

.note_text img {
    width: 35px;
}

.line {
    margin-top: 5px;
    height: 0.5px;
    width: 100%;
    background: rgba(255, 255, 255, 0.25);
    ;
}

.sub_container {
    padding: 0 25px;
}

.sub_container ::v-deep .van-field {
    border-radius: 10px;
    padding: 2vh !important
}

.btn_container ::v-deep .defaultButton .van-button--default {
    border-radius: 10px !important;
    padding: 1.5vw 0;
}

.amount_card {
    border-radius: 5px;
}

.input_field>>>.van-field {
    border-radius: 10px;
    background-color: #ffffff26;
    color: #ffffffd9;
    padding: 12px 20px !important;
    margin-top: 10px;
}

.input_field>>>.van-field__control {
    color: #ffffffa6 !important;
    font-size: 12px;

}

.input_field {
    padding: 10px 0;
}

.inputLabel {
    color: #ffffffd9;
    font-size: 14px;
}

.errorText {
    color: red;
    font-size: 12px;
}

.right-wrapper {
    display: flex;
    align-items: center;
    gap: 8px;
}

.descriptionContainer {
    padding: 15px;
    background: #ffffff2f;
    font-size: 12px;
    color: #fff;
    border-radius: 10px;
    margin: 15px;
}

.noticeText {
    font-size: 14px;
    font-weight: bold;
    padding: 0 0 5px;
    color: #F8D8A7;
}

div :deep(p) {
    margin-bottom: 10px;
    color: #fff;
    line-height: 1.5;
}

div :deep(br) {
    content: "";
    margin: 5px 0;
    display: block;
}

@media (min-width: 1440px) {

    .channel_text,
    .channel_card,
    .balance_text,
    .sub_container,
    .deposit_notice,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default,
    .amount_card,
    .bonus_select ::v-deep .van-checkbox__label,
    .active_channel {
        font-size: 1.8vh !important;
    }

    .deposit_notice {
        padding: 15px;
    }
}

@media (min-width: 1920px) {

    .channel_text,
    .channel_card,
    .balance_text,
    .sub_container,
    .deposit_notice,
    .sub_container ::v-deep .van-field,
    .btn_container ::v-deep .defaultButton .van-button--default,
    .amount_card,
    .bonus_select ::v-deep .van-checkbox__label,
    .active_channel {
        font-size: 1.8vh !important;
    }

    .deposit_notice {
        padding: 15px;
    }
}
</style>